// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"61f60f5c","455":"41ec1e75","977":"882c1446"}[chunkId] + ".chunk.js";
};